<template>
    <DataTable
        ref="processesTable"
        :value="processes"
        v-if="processes"
        selectionMode="single"
        @row-click="
            (event: DataTableRowClickEvent) => {
                const rowLink = `process-link-${event.data.identity}`;
                processesTable.$el.querySelector(`#${rowLink}`)?.click();
            }
        "
    >
        <template #header>
            <div style="display: flex; justify-content: space-between">
                <h2>Processes</h2>
                <Button
                    v-if="isEditing"
                    class="p-button-secondary"
                    icon="pi pi-plus"
                    label="Add process"
                    severity="secondary"
                    text
                    @click="openNewProcess()"
                />
            </div>
        </template>

        <template #empty>
            <div>No process</div>
        </template>
        <Column field="name" header="Name" class="name-col">
            <template #body="{ data, field }">
                <RouterLink
                    :id="`process-link-${data.identity}`"
                    class="process-link"
                    :to="{
                        name: 'processPage',
                        params: {
                            orgName: route.params.orgName,
                            stekName: route.params.stekName,
                            processId: data.identity,
                        },
                    }"
                >
                    <div>
                        {{ data[field] }}
                    </div>
                </RouterLink>
            </template>
        </Column>
        <Column field="short_description" header="Description">
            <template #body="slotProps">
                <template v-if="slotProps.data.short_description">
                    {{ slotProps.data.short_description }}
                </template>
                <p v-else v-tooltip="'A description is not (yet) available'">
                    ...
                </p>
            </template>
        </Column>
    </DataTable>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
import type { DataTableRowClickEvent } from "primevue/datatable";
import type { ProcessInTree } from "@/stores/processes-store";
import { useNewProcessDialog } from "@/composables/new-process-dialog";
import { ref } from "vue";

defineProps<{
    isEditing: boolean;
    processes: ProcessInTree[];
}>();

const processesTable = ref();

const route = useRoute();
const { open: openNewProcess } = useNewProcessDialog();
</script>

<style scoped lang="scss">
.process-link {
    text-decoration: none;
}

:deep(.p-datatable-thead) > tr > th,
:deep(.p-datatable-tbody) > tr > td {
    &.name-col {
        width: 30rem;
    }
}
</style>
